
import React, { useMemo } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './header';
import Footer from './Footer1';

interface DashboardLayoutProps {
  children: ReactNode;
  yourLogo?: string;
  footerLogo?: string;
  configData?: any[];
  base_path?: string;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
  children, 
  yourLogo, 
  footerLogo,
  configData, 
  base_path 
}) => {
  const location = useLocation();

  // Build dynamic cart URL based on current URL parameters (for draft flow)
  const cartUrl = useMemo(() => {
    const urlParams = new URLSearchParams(location.search);
    const draftId = urlParams.get('draftId');
    const campaignName = urlParams.get('campaignName');
    const startDate = urlParams.get('startDate');
    const endDate = urlParams.get('endDate');
    const source = urlParams.get('source');
    const edit = urlParams.get('edit');

    let url = `${base_path}/mycart`;

    // If in draft/edit flow, append draft parameters to cart URL
    if (edit === 'true' && draftId && campaignName) {
      const params = new URLSearchParams({
        draftId,
        campaignName,
        edit: 'true'
      });

      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (source) params.append('source', source);

      url += `?${params.toString()}`;
      console.log('🛒 [DashboardLayout] Cart URL built with draft params:', {
        draftId,
        campaignName,
        startDate,
        endDate,
        source
      });
    }

    return url;
  }, [location.search, base_path]);

  return (
    <div className="dashboard-container">
      <Header yourLogo={yourLogo} configData={configData} base_path={base_path} cartUrl={cartUrl} />
      <main>
        {children}
      </main>
      <Footer configData={configData ?? []} base_path={base_path} yourLogo={footerLogo || yourLogo || ''} />
    </div>
  );
};

export default DashboardLayout;
